<script lang="ts">
import { NotificationDetailsComponent } from "./notification-details.ts";
export default NotificationDetailsComponent;
</script>

<template>
    <section
        class="notifications-section overscroll"
        :class="{ 'is-active': active }"
        :style="{ zIndex: active ? 2 : 1 }"
    >
        <div class="notifications-section__inner">
            <div class="notifications-section__date" ref="date">
                {{ formattedCreatedDate }}
            </div>
            <h2 class="notifications-section__title" ref="title">
                {{ notificationDetails.title }}
            </h2>
            <div
                class="notifications-section__content"
                ref="content"
                v-html="notificationDetails.content"
            ></div>
        </div>
    </section>
</template>
